import { action as apiAction } from 'api/Api'
import sweetalert from 'sweetalert2'

type Payload = {
  cardId: number
  allowRelationsRemoval?: boolean
}

const requestDeleteCard = (payload: Payload) => async (dispatch, getState) => {
  const { cardId, allowRelationsRemoval } = payload

  try {
    await apiAction('RemoveCard', {
      id: cardId,
      allowRelationsRemoval
    })
  } catch (error) {
    if (error.code === 1105) { // Card has relations
      try {
        const state = getState()

        await sweetalert({
          type: 'warning',
          text: state.kanbo.locale.messages['CARD_DELETE_RELATIONS_EXIST'],
          showCancelButton: true,
          confirmButtonClass: 'btn btn-warning',
          confirmButtonText: state.kanbo.locale.messages['YES'],
          cancelButtonText: state.kanbo.locale.messages['NO']
        })

        await dispatch(requestDeleteCard({
          ...payload,
          allowRelationsRemoval: true
        }))
      } catch (e) {}
    } else if (error.code === 522) { // Both cards are archived
      try {
        const state = getState()

        await sweetalert({
          text: state.kanbo.locale.messages['CARD_DELETE_RELATIONS_ARCHIVED'],
          type: 'info'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}

export default requestDeleteCard
